export default __webpack_public_path__ + "static/media/Asraful_Updated_resume (1).7a185339.pdf";